export default __webpack_public_path__ + "static/media/schedule-campaign-1.744f4596.png";